export const STATIC_TFN_MESSAGES = {
  exactDigits: "Static TFN must be exactly 10 numeric digits.",
};

export const validateStaticTfn = (value = "") => {
  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return "";
  }

  if (!/^\d{10}$/.test(normalizedValue)) {
    return STATIC_TFN_MESSAGES.exactDigits;
  }

  return "";
};
